import { Reducer } from 'redux';
import { State } from '../../@types/state';
import { SoundActionTypes } from './types';
import { SoundAction } from './sound.action';

const initialState = {
  pending: false,
  data: {
    sounds: undefined,
  },
  errors: undefined,
  initFetch: true,
};

const sound: Reducer<State['sound'], SoundAction> = (
  state: State['sound'] = initialState,
  action: SoundAction
) => {
  switch (action.type) {
    case SoundActionTypes.GET_SOUNDS_FOR_AN_ORGANIZATION_ID_PENDING: {
      return {
        ...state,
        pending: action.pending,
        errors: undefined,
      };
    }
    case SoundActionTypes.GET_SOUNDS_FOR_AN_ORGANIZATION_ID_SUCCESS: {
      return {
        ...state,
        pending: false,
        data: action.data,
        initFetch: false,
      };
    }
    case SoundActionTypes.GET_SOUNDS_FOR_AN_ORGANIZATION_ID_ERROR: {
      return {
        ...state,
        pending: false,
        errors: action.message,
      };
    }
    default: {
      return state;
    }
  }
};

export default sound;
